import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header.component';
import { RouterModule } from '@angular/router';
import { NavModule } from '@app/theme/nav/nav.module';
import { LeftHeaderSideModule } from './left-header-side/left-header-side.module';
import { SideNavMenuModule } from './side-nav-menu/side-nav-menu.module';
import { RightHeaderSideModule } from './right-header-side/right-header-side.module';

@NgModule({
  declarations: [HeaderComponent],
  imports: [
    CommonModule,
    RouterModule,
    NavModule,
    LeftHeaderSideModule,
    RightHeaderSideModule,
    SideNavMenuModule,
  ],
  exports: [HeaderComponent],
})
export class HeaderModule {}
